import { type Draft } from 'immer'
import { type MonthCalendarResponse } from '../types'

export type ContentMove = {
  /** ISO 8601 instant, or null when the content has no time of its own. */
  scheduledAt: string | null
  /** `yyyy-MM-dd`. */
  scheduledDate: string
  /** `yyyy-MM-dd`, or null when the content has no in-market window. */
  takedownDate: string | null
}

/** Puts a piece of content on a new day, with its in-market window. */
export const moveContent =
  (contentId: string, move: ContentMove) =>
  (draft: Draft<MonthCalendarResponse>) => {
    const content = draft.data.content.by_id[contentId]
    if (content === undefined) return draft

    content.scheduledAt = move.scheduledAt
    content.scheduledDate = move.scheduledDate
    content.takedownDate = move.takedownDate

    return draft
  }
